import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function FireMasterIllustration({
  achievementId,
  variant = 'blaze',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3728" data-mp="3qxfmeo5qlymy">
      <div className="relative w-full h-full bg-gradient-to-b from-red-900 to-stone-900 overflow-hidden" data-id="element-3729" data-mp="4nuueve46t7j">
        {/* Background: Volcano and Smoke */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3730" data-mp="9nzbamixppya">
          {/* Smoke clouds */}
          <circle cx="60" cy="40" r="30" fill="#44403C" fillOpacity="0.6" filter="blur(4px)" data-id="element-3731" data-mp="2bgnjlaafr3kx" />
          <circle cx="140" cy="30" r="40" fill="#292524" fillOpacity="0.7" filter="blur(6px)" data-id="element-3732" data-mp="22h4xa5vedd3g" />
          <circle cx="100" cy="60" r="35" fill="#57534E" fillOpacity="0.5" filter="blur(5px)" data-id="element-3733" data-mp="1sqttqkfml5x3" />

          {/* Embers */}
          <circle cx="50" cy="80" r="2" fill="#FDE047" data-id="element-3734" data-mp="2ldelhm00jk16" />
          <circle cx="150" cy="100" r="1.5" fill="#F97316" data-id="element-3735" data-mp="2gfd1myurjgon" />
          <circle cx="120" cy="50" r="2.5" fill="#EF4444" data-id="element-3736" data-mp="2gfw7hh752emb" />
          <circle cx="80" cy="120" r="1" fill="#FDE047" data-id="element-3737" data-mp="2bfqmgjvdjqd7" />
        </svg>

        {/* Background: Volcano Ground */}
        <svg className="absolute bottom-0 left-0 w-full h-[40%] z-0" viewBox="0 0 200 80" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-3738" data-mp="26g5drhqek3na">
          <path d="M-20 80 L60 20 L140 20 L220 80 Z" fill="#1C1917" data-id="element-3739" data-mp="v0gsqvwplep4" />
          {/* Lava flows */}
          <path d="M70 20 Q80 50 60 80 L80 80 Q90 50 85 20 Z" fill="#EA580C" data-id="element-3740" data-mp="3j8gy3ai1qyzo" />
          <path d="M120 20 Q110 40 130 80 L150 80 Q130 40 135 20 Z" fill="#DC2626" data-id="element-3741" data-mp="3n8ivh7gr1695" />
          <path d="M75 20 Q80 50 65 80 L75 80 Q85 50 80 20 Z" fill="#FDE047" data-id="element-3742" data-mp="3999lipj4z8dm" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-3743" data-mp="3eayw642g5k16">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-3744" data-mp="2ziom4zvn1ztn">
            <DjaySpecimen look={{
            variant,
            accessory: 'doubleFlameCrown'
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3745" data-mp="34bhs1r2ufe7b" />
          </div>
        </div>

        {/* Foreground: Extra Lava/Heat */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3746" data-mp="2ljfa8cegtrvh">
            <path d="M0 200 L40 160 L60 200 Z" fill="#1C1917" data-id="element-3747" data-mp="1xz656pfbiw8o" />
            <path d="M160 200 L180 150 L200 200 Z" fill="#292524" data-id="element-3748" data-mp="2bxe1cv4j5tis" />
            <circle cx="30" cy="180" r="4" fill="#F97316" data-id="element-3749" data-mp="26wymfz4lodyp" />
            <circle cx="180" cy="170" r="3" fill="#EF4444" data-id="element-3750" data-mp="26zkqhosa8bc6" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}